import ApiManager from '../api/crud-manager';
import jsonToView from '../api/json-to-view';

/**
 * Class real time product stock module
 * @class
 * @author Max Swinkels <max.swinkels@pangaea.nl>
 *
 */

class RealTimeStock {
  constructor(options = {}) {
    this.config = {
      moduleList: () => document.querySelectorAll('[data-module="RealTimeStock"]'),
      apiManager: new ApiManager(),
      ...options
    };
  }

  // fetch product stock based on product id
  async getStock(productId) {
    const { apiManager } = this.config;

    const url = `/api/v2/catalog/product/${productId}/stock`;

    return apiManager.get(url).then(data => data);
  }

  init() {
    const { moduleList } = this.config;

    moduleList().forEach(_module => {
      const module = _module;

      const { productId, resourceErrorMessage, initialized, stockRemark } = module.dataset;

      if (!productId && initialized != null && initialized) return;

      module.dataset.initialized = true; // skip initialized module items
      module.classList.add('is-loading');

      this.getStock(productId)
        .then(response => {
          const templateView = 'RealTimeStock';
          const viewData = {
            productId,
            stock: response,
            stockRemark
          };

          // create view based on template file
          jsonToView(viewData, templateView)
            .then(html => {
              module.classList.remove('is-loading');
              module.innerHTML = html;
              $('.js-article-tooltip').tooltip();
            })
            .catch(error => {
              module.classList.remove('is-loading');
              module.innerHTML = resourceErrorMessage || 'Stock not available';
              throw new Error(error);
            });
        })
        .catch(error => {
          module.classList.remove('is-loading');
          module.innerHTML = resourceErrorMessage || 'Stock not available';
          throw new Error(error);
        });
    });
  }
}

export default RealTimeStock;
